export const decodeB2CErrorMessage = message => message.replace(/\+/g, " ");
